
  import { defineComponent } from "@vue/runtime-core"

  export default defineComponent({
    name: "CorrectAnswer",
    props: {
      isDone: Boolean,
      isError: Boolean
    }
  })
